import type { TokenPerformanceLogger } from "./TokenPerformanceLogger";

const ATTEMPT_COUNT = "_AttemptCount";
const BACKOFF_MS = "_BackoffMs";

export function recordRetryAttempt(perfLog: TokenPerformanceLogger, prefix: string, attemptIndex: number, backoffAccumulatedMs: number): void {
    perfLog.addCustomProperty(prefix + ATTEMPT_COUNT, attemptIndex);
    perfLog.addCustomProperty(prefix + BACKOFF_MS, backoffAccumulatedMs);
}

export function recordRetryFailure(perfLog: TokenPerformanceLogger, prefix: string, attemptIndex: number, backoffAccumulatedMs: number): void {
    perfLog.addCustomProperty(prefix + ATTEMPT_COUNT, attemptIndex);
    perfLog.addCustomProperty(prefix + BACKOFF_MS, backoffAccumulatedMs);
}
